import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchSimulation } from '../client';
import { useSimulationId } from './useSimulationId';

export function useResetSimulation() {
  const simId = useSimulationId();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async () => {
      await patchSimulation({
        path: { sim_id: simId },
        body: { state: 'not-started' },
        throwOnError: true,
      });
    },
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ['dashboardData'] });
      queryClient.removeQueries({ queryKey: ['features-with-team-context'] });
      queryClient.removeQueries({ queryKey: ['features'] });
      queryClient.removeQueries({ queryKey: ['team-tasks'] });
      queryClient.removeQueries({ queryKey: ['task'] });
      queryClient.invalidateQueries();
    },
  });

  return mutation;
}
